import type { SVGProps } from 'react';

const SvgQuoteInverted = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 33 24" {...props}>
    <path
      fill={props.color}
      d="M19.1 22.513V24C27.8 23.15 33 16.673 33 8.283 33 3.186 30.135 0 25.785 0c-3.82 0-6.791 2.867-6.791 6.478 0 3.823 2.334 6.265 5.942 6.265 1.591 0 2.865-.53 3.926-1.38-.106 6.372-4.775 10.088-9.762 11.15M0 6.478c0 3.823 2.334 6.265 5.942 6.265 1.592 0 2.865-.53 3.926-1.38-.106 6.372-4.775 10.088-9.762 11.15V24c8.701-.85 13.9-7.327 13.9-15.717C14.006 3.186 11.142 0 6.791 0 2.971 0 0 2.867 0 6.478"
    />
  </svg>
);

export default SvgQuoteInverted;
